import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AccessListService } from './access-list.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AccessGaurdService implements CanActivate{
  submenu: any[] = [];
  constructor(private router: Router, private list: AccessListService) {
  }
  
  canActivate(router, state: RouterStateSnapshot): Observable<boolean> {
    return this.list.checkUrl(state.url).pipe(map(data => data));
  }
  
}



// WEBPACK FOOTER //
// ./src/app/theme/services/access-gaurd.service.ts